module.exports = __webpack_public_path__ + "img/logo_white.aab09de1.svg";